module.exports = __webpack_public_path__ + "media/images/svg/lafluence-d94ae783acb978b9be81e1d3f1426731.svg";